import { render } from "./NavbarHeader.vue?vue&type=template&id=90777688"
import script from "./NavbarHeader.vue?vue&type=script&lang=js"
export * from "./NavbarHeader.vue?vue&type=script&lang=js"

import "./NavbarHeader.vue?vue&type=style&index=0&id=90777688&lang=css"

import exportComponent from "/mnt/projects/panel.doctor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__